import '../../stylesheets/users/devise';
import '../../stylesheets/users/passwords';

import * as formComponent from './../components/form';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // フォームのアクション
  formComponent.temporarilySave();
})
